import React from 'react'
import Button from '@material-ui/core/Button'
import Icon from '@material-ui/core/Icon'
import Link from 'shared-ui/components/Link'
import IntlUtil from 'shared-ui/utils/IntlUtil'
import PortalLabels from '~src/constants/PortalLabels'

export default function NoDistributorData({
  className,
  title,
  buttonText,
  accountCode,
  outerClassName,
  buttonClassName,
}) {
  const basepath = window.location.search ? `${window.location.search}&edit=true` : `?edit=true`
  return (
    <div
      className={`rounded-outer flex w-full flex-col items-center justify-center gap-4 ${outerClassName}`}
      onClick={e => e.stopPropagation()}
    >
      <div
        className={`border-orange flex w-full items-center justify-start gap-3 border-t-[1px] pt-4 ${className}`}
      >
        <Icon className="text-orange">warning</Icon>
        <div className={''}>{title || IntlUtil.label(PortalLabels.WS_NO_DISTRIBUTORS)}</div>
      </div>
      <Link to={`${basepath}#distributor_assignment/${accountCode}`} className="w-full">
        <Button
          className={`w-full ${buttonClassName}`}
          variant="contained"
          color="primary"
          onClick={e => e.stopPropagation()}
        >
          {buttonText || IntlUtil.label(PortalLabels.WS_ADD_DISTRIBUTOR)}
        </Button>
      </Link>
    </div>
  )
}
